var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',{staticClass:"rv-error",style:({ 
    width: this.imageEditorWidth + 'px',
    height: this.imageEditorHeight + 'px'
    })},[_vm._t("error")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }